import HomeProduct from './HomeProductPage';

export default HomeProduct;
